// extracted by mini-css-extract-plugin
export default {"container":"WalkthroughInitializer_container__FkUTD","message":"WalkthroughInitializer_message__P8fHs"};